import React from 'react';
import { ShopContainer, Title, ShopItem, ShopItemImage, ShopItemInfo, ShopItemTitle, ShopItemDescription, ShopItemPrice, Button } from '../styles/StyledComponents';

interface ShopItemData {
  id: string;
  name: string;
  description: string;
  price: number;
  purchased: boolean;
}

interface ShopScreenProps {
  items: ShopItemData[];
  totalCoins: number;
  onPurchase: (itemId: string) => void;
  onBack: () => void;
}

const ShopScreen: React.FC<ShopScreenProps> = ({
  items,
  totalCoins,
  onPurchase,
  onBack
}) => {
  return (
    <ShopContainer>
      <Title>상점</Title>
      
      <div style={{ color: 'white', marginBottom: '20px' }}>
        보유 코인: {totalCoins}
      </div>
      
      {items.map(item => (
        <ShopItem key={item.id}>
          <ShopItemImage />
          <ShopItemInfo>
            <ShopItemTitle>{item.name}</ShopItemTitle>
            <ShopItemDescription>{item.description}</ShopItemDescription>
          </ShopItemInfo>
          {item.purchased ? (
            <div style={{ color: '#1dd1a1', fontWeight: 'bold' }}>구매 완료</div>
          ) : (
            <ShopItemPrice>
              {item.price} 코인
              <button 
                style={{ 
                  marginLeft: '10px', 
                  padding: '5px 10px', 
                  backgroundColor: totalCoins >= item.price ? '#ff4757' : '#485460',
                  color: 'white',
                  borderRadius: '4px',
                  border: 'none',
                  cursor: totalCoins >= item.price ? 'pointer' : 'not-allowed'
                }}
                onClick={() => totalCoins >= item.price && onPurchase(item.id)}
                disabled={totalCoins < item.price}
              >
                구매
              </button>
            </ShopItemPrice>
          )}
        </ShopItem>
      ))}
      
      <Button onClick={onBack} style={{ marginTop: '20px' }}>돌아가기</Button>
    </ShopContainer>
  );
};

export default ShopScreen;
